import Link from '@tiptap/extension-link';
import { PasteRule, PasteRuleFinder, PasteRuleMatch } from '@tiptap/react';

/**
 * Tiptap flattens every non-text leaf node (hard break, mention, inline image) into a single
 * U+FFFC placeholder before it runs the paste rules, and linkify treats that placeholder as an
 * ordinary URL character. Pasting `<a href="…">https://example.com</a><br>and more text` therefore
 * links `https://example.com<placeholder>and` as one URL with a broken href.
 *
 * Running the original finder on each placeholder-separated segment makes a leaf node end a URL
 * the same way a space does. A leaf takes up exactly one character in the flattened text and one
 * position in the document, so shifting each match by the segment offset keeps the ranges aligned.
 */
const LEAF_PLACEHOLDER = '\ufffc';

function findInLeafSeparatedSegments(
  findLinks: (text: string, event?: ClipboardEvent | null) => PasteRuleMatch[] | null | undefined,
  text: string,
  event?: ClipboardEvent | null
): PasteRuleMatch[] {
  const matches: PasteRuleMatch[] = [];
  let offset = 0;
  text.split(LEAF_PLACEHOLDER).forEach((segment) => {
    findLinks(segment, event)?.forEach((match) => {
      matches.push({ ...match, index: match.index + offset });
    });
    offset += segment.length + LEAF_PLACEHOLDER.length;
  });
  return matches;
}

export const CustomLink = Link.extend({
  addPasteRules() {
    const rules = this.parent?.() || [];
    return rules.map((rule) => {
      const findLinks: PasteRuleFinder = rule.find;
      if (typeof findLinks !== 'function') return rule;
      return new PasteRule({
        find: (text, event) => findInLeafSeparatedSegments(findLinks, text, event),
        handler: rule.handler
      });
    });
  }
});
